// extracted by mini-css-extract-plugin
export default {"overlay":"ImageLightbox_overlay__j-0Yy","image":"ImageLightbox_image__2DrsF","closeButton":"ImageLightbox_closeButton__w2O1g"};